import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import FormLabel from "@material-ui/core/FormLabel";

import Button from "common/components/CustomButtons/Button.jsx";

// @material-ui/core components
import Phone from "@material-ui/icons/Phone";

import loadContent from "core-module/hoc/loadContent";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px",
    fontSize: "18px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center",
    fontSize: "15px"
  },
  containerLine: {
    marginTop: "20px"
  },
  editButton: {
    textAlign: "right",
    margin: "10px"
  }
};

const PhoneBasicSettings = props => {
  const { classes } = props;

  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Phone />
        </CardIcon>
        <h4 className={classes.cardIconTitle}> Basic Settings</h4>
      </CardHeader>
      <CardBody>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>
              No Internet Forward
            </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.datainfo}>
              {props.getData("cf_unavailableenabled", "display")}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>
              No Internet Forward Number
            </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.datainfo}>
              {props.getData("cf_unavailablenumber")}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>
              Ringing Timeout
            </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.datainfo}>
              {props.getData("vm_timeout", "display")}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="flex-end">
          <GridItem className={classes.editButton} xs={12}>
            <Button
              color="primaryLightBlue"
              onClick={() =>
                props.onClickEditBasicSettings(
                  props.getData("billingpackageserviceid")
                )
              }
            >
              Edit
            </Button>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(
  loadContent(
    "user.session/billingpackage.props/voipfeatures",
    PhoneBasicSettings
  )
);
